module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "layout-breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("系统管理")])]), _vm._v(" "), _c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("SQL监控")])])], 1)], 1), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-content"
  }, [_c('div', {
    staticStyle: {
      "padding": "50px 20px"
    }
  }, [_vm._v(" \n         嵌入sql页面\n       ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09cde0b6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SystemManage/sql.vue
// module id = 889
// module chunks = 1